import { useEffect, useMemo, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import {CheckCircle2, ExternalLink, Play} from 'lucide-react'
import {
  CURSOS_AROMATERAPIA,
  isCursoAromaterapiaId,
  youtubeEmbedUrl,
} from '@/data/cursosAromaterapia'

function CursoAromaterapiaAulas() {
  const { cursoId } = useParams()
  const curso = isCursoAromaterapiaId(cursoId) ? CURSOS_AROMATERAPIA[cursoId] : null
  const [aulaAtiva, setAulaAtiva] = useState(1)
  const [nome, setNome] = useState('')

  useEffect(() => {
    window.scrollTo(0, 0)
    if (!curso) return
    try {
      setNome(sessionStorage.getItem(`curso_${curso.id}_nome`) || '')
    } catch {
      // ignore
    }
  }, [curso])

  const aula = useMemo(() => {
    if (!curso) return null
    return curso.aulas.find((a) => a.numero === aulaAtiva) || curso.aulas[0]
  }, [curso, aulaAtiva])

  if (!curso || !aula) {
    return (
      <div className="min-h-screen bg-[#F8F4EF] flex items-center justify-center px-4">
        <p className="text-[#5F5E5A]">Curso não encontrado.</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#F8F4EF]">
      <header className="bg-white border-b border-[#EDE0D4] sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-3">
          <div>
            <p className="font-cormorant text-lg font-semibold text-[#2D6A4F]">
              Diagnóstico Saúde e Emoções
            </p>
            <p className="text-xs text-[#5F5E5A]">{curso.titulo}</p>
          </div>
          {nome ? <p className="text-sm text-[#2C2C2A] hidden sm:block">Olá, {nome.split(' ')[0]}</p> : null}
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_280px] gap-6">
          <div>
            <div className="bg-black rounded-2xl overflow-hidden aspect-video mb-5">
              <iframe
                key={aula.youtubeId}
                src={youtubeEmbedUrl(aula.youtubeId)}
                title={aula.titulo}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <h1 className="font-cormorant text-2xl sm:text-3xl font-semibold text-[#2C2C2A] mb-4">
              {aula.titulo} — {curso.titulo}
            </h1>
            <a
              href={curso.materialUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#2D6A4F] text-white font-medium px-6 py-3 rounded-full hover:bg-[#1f4f3a] transition-colors"
            >
              Material da Aula
              <ExternalLink size={16} />
            </a>
          </div>

          <aside className="bg-white rounded-2xl border border-[#EDE0D4] p-4 h-fit">
            <p className="text-xs uppercase tracking-wide text-[#B08968] font-medium mb-3">
              Aulas do curso
            </p>
            <div className="space-y-2">
              {curso.aulas.map((item) => {
                const ativa = item.numero === aulaAtiva
                return (
                  <button
                    key={item.numero}
                    type="button"
                    onClick={() => setAulaAtiva(item.numero)}
                    className={`w-full text-left px-3 py-3 rounded-xl border flex items-center gap-2 transition-colors ${
                      ativa
                        ? 'border-[#52B788] bg-[#D8F3DC] text-[#2D6A4F]'
                        : 'border-[#EDE0D4] hover:border-[#52B788]/50 text-[#2C2C2A]'
                    }`}
                  >
                    {ativa ? <CheckCircle2 size={16} /> : <Play size={16} />}
                    <span className="text-sm font-medium">{item.titulo}</span>
                  </button>
                )
              })}
            </div>
          </aside>
        </div>

        <p className="text-center text-sm text-[#5F5E5A] mt-10">
          <Link to={`/cursos/${curso.id}`} className="hover:underline">
            Voltar à apresentação do curso
          </Link>
        </p>
      </main>
    </div>
  )
}

export default CursoAromaterapiaAulas
